import {
  BORDER_WIDTH_PX,
  CHEVRON_GAP,
  CHEVRON_WIDTH,
  DEFAULT_WIDTH,
  INPUT_SPACE,
  PADDING_LEFT,
  PADDING_RIGHT,
  ROOT_FONT_SIZE_PX,
  ROW_GAP,
  SMALL_PADDING_LEFT,
  SMALL_PADDING_RIGHT,
  parseCssSizeToPx,
} from "../Select.Parts";
import {
  Props,
  calculateVisibleSelections,
} from "./UseSelectionVisibility.Parts";

/**
 * Calculates the number of visible selection pills in the Select Button based on width constraints.
 */
export const useSelectionVisibility = ({
  selections,
  getLabelForValue,
  maxWidth,
  width,
  rows,
  search,
  small,
  anchorEl,
  containerWidth,
}: Props) => {
  const horizontalPadding = small
    ? SMALL_PADDING_LEFT + SMALL_PADDING_RIGHT
    : PADDING_LEFT + PADDING_RIGHT;
  const UNUSABLE_SPACE =
    (horizontalPadding +
      CHEVRON_GAP +
      CHEVRON_WIDTH +
      (search ? ROW_GAP + INPUT_SPACE : 0)) *
      ROOT_FONT_SIZE_PX +
    2 * BORDER_WIDTH_PX;

  const visibleCount = () => {
    const maxWidthValue = maxWidth || width;
    const selectedLabels = selections.map(getLabelForValue);

    const fixedMaxWidth = parseCssSizeToPx(maxWidthValue);
    if (fixedMaxWidth) {
      return calculateVisibleSelections(
        selectedLabels,
        fixedMaxWidth - UNUSABLE_SPACE,
        rows,
      );
    }

    let calculatedMaxWidth;
    if (maxWidthValue.endsWith("%") && containerWidth) {
      const parentWidth =
        anchorEl?.parentElement?.offsetWidth || containerWidth;
      const percentage = parseFloat(maxWidthValue) / 100;
      calculatedMaxWidth = parentWidth * percentage - UNUSABLE_SPACE;
    } else if (maxWidthValue.endsWith("vw")) {
      const viewportWidth = window.innerWidth;
      const percentage = parseFloat(maxWidthValue) / 100;
      calculatedMaxWidth = viewportWidth * percentage - UNUSABLE_SPACE;
    } else {
      calculatedMaxWidth = DEFAULT_WIDTH * ROOT_FONT_SIZE_PX - UNUSABLE_SPACE;
    }

    return calculateVisibleSelections(selectedLabels, calculatedMaxWidth, rows);
  };

  const count = visibleCount();
  const visibleSelections = selections.slice(0, count);
  const overflowCount = selections.length - count;

  return {
    visibleSelections,
    overflowCount,
  };
};
